// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumb_root__X8HjU"};